import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { StatusRequest } from '../shared/model/status-request.model';

@Component({
  selector: 'app-status-dialog',
  templateUrl: './status-dialog.component.html',
  styleUrls: ['./status-dialog.component.scss']
})
export class StatusDialogComponent implements OnInit {

  displayedColumns: string[] = ['estado', 'fecha', 'semestre' , 'materia' , 'nombrematera' ,
  'semestrereconocer' , 'materiareconoer', 'nommateriareconoer', 'nota'];
  request:  StatusRequest[];

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
  public dialogRef: MatDialogRef<StatusDialogComponent>) {
    this.request = data.request;
   }

  ngOnInit() {
  }

  close() {
    this.dialogRef.close(0);
  }

  getColorStatus(color) {
    switch (color) {
      case 'Rechazada':
      return 'red';

      case 'Pendiente':
      return 'blue';

      case 'Aceptada':
      return 'green';


    }

  }

}
